module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-ru-RU.7baad9a6.jpg";